<template>
  <v-row align="center" justify="center">
    <v-col cols="12" md="12" sm="12">
      <h3 class="font-weight-black mb-5">Catálogo CIE10</h3>
    </v-col>
    <v-col cols="12" md="12" sm="12">
      <validation-provider v-slot="{ errors, invalid, touched }" name="Diagnostico" rules="required">
        <v-autocomplete v-model="model.cie10List" label="Diagnóstico" no-data-text="Sin resultados por mostrar" dense
          chips deletable-chips clearable :clear-icon="$cnst.CLEAR_ICON" multiple required :error-messages="errors"
          :items="cie" :item-text="cie.text" :item-value="cie.value" :disabled="isViewDetailsForm"><v-icon slot="append"
            :color="touched && invalid ? 'error' : ''">
            {{ touched && invalid ? "mdi-alert" : "" }}
          </v-icon>
        </v-autocomplete>
      </validation-provider>
    </v-col>
    <v-divider vertical></v-divider>
    <v-col cols="12" md="8" sm="12" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
      <span>Detalles de diagnóstico</span>
      <validation-provider v-slot="{ errors, touched, invalid }" name="Detalles de diagnóstico" rules="required">
        <v-textarea v-model="model.diagnosticDetail" solo :error-messages="errors" :counter="1000" :maxlength="1000"
          outlined dense clearable :clear-icon="$cnst.CLEAR_ICON" auto-grow required :disabled="isViewDetailsForm"
          rows="6"><v-icon slot="append" :color="touched && invalid ? 'error' : ''">
            {{ touched && invalid ? "mdi-alert" : "" }}
          </v-icon>
        </v-textarea>
      </validation-provider>
    </v-col>
    <v-col >
      <validation-provider v-slot="{ errors, valid }" name="Diagnóstico subsecuente" rules="required">
        <v-autocomplete label="Diagnóstico subsecuente*" v-model="model.subsequent" :error-messages="errors" dense
          no-data-text="Sin resultados disponibles" required :clear-icon="$cnst.CLEAR_ICON" clearable
          :disabled="isViewDetailsForm" :items="['SI', 'NO']">
          <v-icon slot="append" :color="valid ? 'success' : ''">
            {{ valid ? " mdi-check" : "" }}
          </v-icon>
        </v-autocomplete>
      </validation-provider>
    </v-col>
  </v-row>
</template>

<script>
import { CieRequest } from "@/core/request";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    saveCie10Changes: Boolean,
    isUpdate: Boolean,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      cie: [],
      cieSelected: [],
      hasSubsequent: true
    };
  },
  mounted() {
    this.getCieCatalogue();
    this.validateSubsequent();
  },
  methods: {
    validateSubsequent() {
      if (this.isUpdate === true) {
        this.hasSubsequent = this.$utilFront.nonEmpty(this.model.subsequent);
      }
    },
    returnCieSelected() {
      if (this.model.cie10List.length > 0) {
        for (let k in this.model.cie10List) {
          for (let v in this.cie) {
            if (this.model.cie10List[k] == this.cie[v].value) {
              this.cieSelected.push(this.cie[v]);
            }
          }
        }
        let list = [...new Set(this.cieSelected)];
        this.cieSelected = list;
      }
    },
    async getCieCatalogue() {
      await CieRequest.listAllCie()
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.cie = res.data.data.map((data) => {
              let cieText = `${data.key} - ${data.name}`;
              return {
                value: data.idCIE10,
                text: cieText,
              };
            });
          }
        })
        .finally(() => {
          //change action to table
          // this.asignCie10();
        });
    },
    asignCie10() {
      if (this.model.cie10List != null) {
        for (let m in this.model.cie10List) {
          for (let r in this.cie) {
            if (this.model.cie10List[m] == this.cie[r].value) {
              this.cieSelected.push(this.cie[r]);
            }
          }
        }
      }
      // this.cieSelected = this.model.cie10List;
    },
    fillCie10() {
      let withoutText = this.cieSelected.map((id) => {
        return id.value;
      });
      this.model.cie10List = withoutText;
    },
  },
};
</script>
